module.exports = __webpack_public_path__ + "static/media/31_B.1bdaf222.png";